let _ = require('../_.js');
let $ = jQuery;

let has_subscribed = false;

_.auctionui_summary_init = async function () {
    _.on_ui_update_once(".btn-show-auction-summary", function () {
        $(this).click(async function () {
            await _.Modal.close_unhidable();
            _.show_the_auction_summary_modal();
        })
    });
}

_.auctionui_summary_html = async function (auction, registrant_id = null) {
    try {
        return await _.backend_ajax('auctions', 'get_registrant_auction_summary_html', { auction_id: auction.id });
    } catch (error) {
        // console.error(error);
        _.flash_error(error);
        return null;
    }
}

_.show_the_auction_summary_modal = async function () {
    $("#ac-modal-auction-sale-summary-modal").modal_show();
    let $body = $("#ac-modal-auction-sale-summary-data");
    $body.html("Please wait...");
    let data = await _.auctionui_summary_html(_.ac_state.auction);
    $body.empty().html(data);

    $("#btn-show-auction-summary-print").off('click').on('click', function (e) {
        e.preventDefault();
        let html = $("#ac-modal-auction-sale-summary-data").html();
        let w = window.open('', '_blank');
        w.document.write('<html><head><title>Auction Sale &amp; Summary</title>');
        w.document.write('<style>body { font-family: Arial, sans-serif; font-size: 14px; padding: 20px; } table { border-collapse: collapse; width: 100%; } td, th { border: 1px solid #ccc; padding: 6px 10px; } @media print { body { padding: 0; } }</style>');
        w.document.write('</head><body>');
        w.document.write(html);
        w.document.write('</body></html>');
        w.document.close();
        w.print();
    });
}

